import { QuoteDeclarationSearchRequestQuery } from '@lio/api-types';

export const quoteDeclarationQueryKeys = {
  search: ['quoteDeclaration'] as const,
  searchWithParams: (quoteId: string, params: QuoteDeclarationSearchRequestQuery) =>
    [...quoteDeclarationQueryKeys.search, quoteId, params] as const,
};
